import { Activity } from "./Activity";
export class Image360Activity extends Activity {
    constructor(isCompleted, title, points, image) {
        super();
        this.isCompleted = isCompleted;
        this.title = title;
        this.points = points;
        this.image = image;
    }
}
